import React from 'react';
import reactDom from '../../../../common/react/dom/index';
import CartCompleted from '../../../../components/frontend/cart/completed';

export default function init() {
	reactDom(<CartCompleted />, 'js-react-completedorder');
}
